import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const getSubCategoryBillPaymentThunk = createAsyncThunk(
    `GetSubCategoryBillPaymentSlicer/getSubCategoryBillPaymentThunk`,
    async (_, { getState }) => {
        const { user } = getState().oidc;

        const participantId = user.profile['custom:participant_id'];

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: participantId,
            username: user.profile.username || user.profile['custom:login'],
        };

        const { data } = await conciergeApiClient.get(
            `BillPayment/GetServices`,
            {
                headers,
            });
        return data;
    }
);

const initialState = {
    dataGetSubCategoryBillPayment: [],
    loadingGetSubCategoryBillPayment: false,
    errorGetSubCategoryBillPayment: false,
};

const GetSubCategoryBillPaymentSlicer = createSlice({
    name: 'GetSubCategoryBillPayment',
    initialState,
    reducers: {
        resetDataGetSubCategoryBillPayment: (state) => {
            state.dataGetSubCategoryBillPayment = [];
            state.loadingGetSubCategoryBillPayment = false;
            state.errorGetSubCategoryBillPayment = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getSubCategoryBillPaymentThunk.pending, (state) => {
            state.dataGetSubCategoryBillPayment = [];
            state.loadingGetSubCategoryBillPayment = true;
            state.errorGetSubCategoryBillPayment = false;
        });
        builder.addCase(getSubCategoryBillPaymentThunk.fulfilled, (state, action) => {
            state.dataGetSubCategoryBillPayment = action.payload;
            state.loadingGetSubCategoryBillPayment = false;
            state.errorGetSubCategoryBillPayment = false;
        });
        builder.addCase(getSubCategoryBillPaymentThunk.rejected, (state) => {
            state.dataGetSubCategoryBillPayment = [];
            state.loadingGetSubCategoryBillPayment = false;
            state.errorGetSubCategoryBillPayment = true;
        });
    },
});

export const { resetDataGetSubCategoryBillPayment } = GetSubCategoryBillPaymentSlicer.actions;
export default GetSubCategoryBillPaymentSlicer.reducer;